/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.CancellationReasons {
  "use strict";

  export class CancellationReasonsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      trackingService: Meevo.Components.Tracking.ITrackingService) {

      super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

      this.baseEndpoint = appSettings.API_ENDPOINTS.cancellationReason;
      this.sectionTemplatePath = "app/plugins/cancellationReasons/sectionViews/";

      this.buildCrudSecurityKeys(this.securityKeys.DATA_CANCELLATIONREASON_TAB_MAIN);
      this.entityType = 'CancellationReason';
    }

    initializeSections(): void {
       if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CANCELLATIONREASON_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
            this.sections.push(new MainSection(0, "SECTION_CANCELLATION_REASONS_MAIN", "main.html", true, false,
              this.appSettings.API_ENDPOINTS.cancellationReason, "",
              this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.CancellationReasonMain, null, this.securityKeys.DATA_CANCELLATIONREASON_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
       }
    }

    initializeHeader(model:any): void {
        this.headerContent = model.displayName;
        this.businessTypeDetail = model.businessTypeDetail;
    }
   
    postCopy(): void {
        super.postCopy();
        let model = this.castModel <Model.CancellationType>();
        model.displayName = undefined;
    }

  }
}